module.exports = __webpack_public_path__ + "img/check_green.cb22751f.svg";